import { useLayoutEffect, useRef } from "react";
import { useToaster } from "rsuite";
import { registerToasterPush } from "./utils";

function ToasterBridge() {
  const toaster = useToaster();
  const pushRef = useRef(toaster.push);

  pushRef.current = toaster.push;

  useLayoutEffect(() => {
    registerToasterPush((message, options) => pushRef.current(message, options));
    return () => registerToasterPush(null);
  }, []);

  return null;
}

export default ToasterBridge;
